import React from 'react';
import { Button } from '@/components/Button';

interface ResetFiltersButtonProps {
  /** Shown only while the list is narrowed; filters now survive a refresh. */
  visible: boolean;
  onReset: () => void;
  className?: string;
}

/** Clears a list's search, filters, date range and sort in one click. */
const ResetFiltersButton: React.FC<ResetFiltersButtonProps> = ({
  visible,
  onReset,
  className = '',
}) =>
  visible ? (
    <Button
      variant="white"
      size="small"
      onClick={onReset}
      className={`whitespace-nowrap ${className}`}
    >
      <i className="ri-filter-off-line mr-1" aria-hidden />
      Reset filter
    </Button>
  ) : null;

export default ResetFiltersButton;
